var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs"),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "search-btn-span": 24,
          "label-width": "120px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "单据号" } },
                      [
                        _c("BjInputCode", {
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.queryCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "queryCode", $$v)
                            },
                            expression: "queryParams.queryCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channelTypeCode", "shopIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "买家昵称" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.buyNick,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "buyNick", $$v)
                            },
                            expression: "queryParams.buyNick",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "出库状态" } },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.ORDER_STOCK_OUT_TYPE_LIST,
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "发货仓库" } },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            "type-code": ["logic"],
                            "value-code": "code",
                          },
                          model: {
                            value: _vm.queryParams.outLogicWarehouseCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "outLogicWarehouseCode",
                                $$v
                              )
                            },
                            expression: "queryParams.outLogicWarehouseCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "出库单创建时间", prop: "" } },
                      [
                        _c("el-date-picker", {
                          staticClass: "full-width",
                          attrs: {
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            type: "datetimerange",
                            "picker-options": _vm.$pickerOptions(),
                            align: "right",
                            "start-placeholder": _vm.$t("form.startDateText"),
                            "end-placeholder": _vm.$t("form.endDateText"),
                            "default-time": ["00:00:00", "23:59:59"],
                          },
                          model: {
                            value: _vm.queryParamsTime_create,
                            callback: function ($$v) {
                              _vm.queryParamsTime_create = $$v
                            },
                            expression: "queryParamsTime_create",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "物流业务" } },
                      [
                        _c("BjSelectLogisticBusiness", {
                          model: {
                            value: _vm.queryParams.logisticBusinessId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "logisticBusinessId",
                                $$v
                              )
                            },
                            expression: "queryParams.logisticBusinessId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "物流单号" } },
                      [
                        _c("BjInputCode", {
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsNo", $$v)
                            },
                            expression: "queryParams.logisticsNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "获取物流单号" } },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "STOCK.ODO_WAYBILL_STATUS" },
                          model: {
                            value: _vm.queryParams.waybillStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "waybillStatus", $$v)
                            },
                            expression: "queryParams.waybillStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "面单打印状态" } },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list":
                              _vm.LOGISTICS_WAYBILL_PRINT_STATUS__LIST,
                          },
                          model: {
                            value: _vm.queryParams.waybillPrintStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "waybillPrintStatus",
                                $$v
                              )
                            },
                            expression: "queryParams.waybillPrintStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品名称/编码" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.spu,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "spu", $$v)
                            },
                            expression: "queryParams.spu",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("goodsPage.skuCode") } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "SKU种类数" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    min: 0,
                                    precision: 0,
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: _vm.queryParams.skuTypeMin,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "skuTypeMin",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.skuTypeMin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 2 },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    min: 0,
                                    precision: 0,
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: _vm.queryParams.skuTypeMax,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "skuTypeMax",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.skuTypeMax",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品数量" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    min: 0,
                                    precision: 0,
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: _vm.queryParams.skuQtyMin,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "skuQtyMin",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.skuQtyMin",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 2 },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 11 } },
                              [
                                _c("el-input-number", {
                                  staticClass: "full-width",
                                  attrs: {
                                    min: 0,
                                    precision: 0,
                                    "controls-position": "right",
                                  },
                                  model: {
                                    value: _vm.queryParams.skuQtyMax,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "skuQtyMax",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.skuQtyMax",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "seniorForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "出库类型" } },
                      [
                        _c("BjSelectLov", {
                          attrs: { "lov-code": "STOCK.OUT_TYPE" },
                          model: {
                            value: _vm.queryParams.outType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "outType", $$v)
                            },
                            expression: "queryParams.outType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "收件姓名" } },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("inputText"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.receiverName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "receiverName", $$v)
                            },
                            expression: "queryParams.receiverName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c("BjFormItemMobile", {
                      attrs: {
                        prop: "receiverPhone",
                        label: "收件手机",
                        clearable: "",
                      },
                      model: {
                        value: _vm.queryParams.receiverPhone,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "receiverPhone", $$v)
                        },
                        expression: "queryParams.receiverPhone",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收件省份",
                          prop: "receiverProvinceCode",
                        },
                      },
                      [
                        _c("BjSelectChinaArea", {
                          staticClass: "full-width",
                          on: { change: _vm.onChangeProvince },
                          model: {
                            value: _vm.queryParams.receiverProvinceCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "receiverProvinceCode",
                                $$v
                              )
                            },
                            expression: "queryParams.receiverProvinceCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "买家备注" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.STATUS_HAVE_TRUE,
                                  },
                                  model: {
                                    value: _vm.queryParams.buyMsgFlag,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "buyMsgFlag",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.buyMsgFlag",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 1 },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 15 } },
                              [
                                _c("BjInput", {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.REMARK,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryParams.buyMsg,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParams, "buyMsg", $$v)
                                    },
                                    expression: "queryParams.buyMsg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "客服备注" } },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 8 } },
                              [
                                _c("BjSelectLov", {
                                  attrs: {
                                    "option-list": _vm.STATUS_HAVE_TRUE,
                                  },
                                  model: {
                                    value: _vm.queryParams.orderMsgFlag,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryParams,
                                        "orderMsgFlag",
                                        $$v
                                      )
                                    },
                                    expression: "queryParams.orderMsgFlag",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              {
                                staticClass: "text-center",
                                attrs: { span: 1 },
                              },
                              [_vm._v("-")]
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 15 } },
                              [
                                _c("BjInput", {
                                  attrs: {
                                    maxlength: _vm.MAX_LENGTH.REMARK,
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryParams.orderMsg,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryParams, "orderMsg", $$v)
                                    },
                                    expression: "queryParams.orderMsg",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function (tableOperationProp) {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: { click: _vm.onPrint },
                      },
                      [_vm._v("打印面单")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onShowDialog("batchSendStock")
                          },
                        },
                      },
                      [_vm._v("批量发货")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSelected,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onShowDialog("getLogisticsNo")
                          },
                        },
                      },
                      [_vm._v("获取物流单号")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: tableOperationProp.notSingle,
                        },
                        on: { click: _vm.onForceDeliver },
                      },
                      [_vm._v("强制发货")]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var row = ref.row
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "code"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.onView(row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row[col.prop]) + " "
                                            ),
                                          ]
                                        )
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_STOCK_OUT_TYPE_LIST.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "waybillStatusMeaning"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(row[col.prop]) +
                                              " " +
                                              _vm._s(
                                                row.waybillStatus !== "GETED"
                                                  ? row.waybillMessage
                                                  : ""
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "waybillPrintStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: row[col.prop]
                                                ? "success"
                                                : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.LOGISTICS_WAYBILL_PRINT_STATUS__LIST.bjGet(
                                                    row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                row[col.prop],
                                                row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialog", { ref: "Dialog" }),
      _c("PrintDialog", { ref: "PrintDialog", on: { reFresh: _vm.reFresh } }),
      _c("DeliverGoodsDialog", {
        ref: "DeliverGoods",
        on: { reFresh: _vm.reFresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }